module.exports = __webpack_public_path__ + "static/media/Drakes-Crossing-bylaws.dfb8531d.pdf";